<template>
  <v-navigation-drawer
    :value="isOpenTemplateEventEditor"
    :permanent="isOpenTemplateEventEditor"
    temporary
    fixed
    right
    width="600"
    max-width="100vw"
    style="transition: 0.5s cubic-bezier(0.4, 0, 0.2, 1);"
    color="grey lighten-3"
  >
    <v-card min-height="100vh" color="grey lighten-3">
      <BaseToolbar
        :title="title"
        type-title="text"
        :button-save="true"
        @close="close"
        @save="submit"
      />
      <v-card-text class="pa-0" style="overflow-y: auto;height: calc(100vh - 64px)">
        <v-container class="py-10">
          <v-row justify="center">
            <v-col cols="12" md="10">
              <v-card>
                <v-card-text class="pa-4">
                  <v-row dense>
                    <v-col cols="12" md="6">
                      <v-select
                        v-model="payload.type"
                        v-validate="'required'"
                        :items="typeOptions"
                        :label="$t('template_events.fields.type')"
                        :data-vv-name="$t('template_events.fields.type')"
                        :error-messages="errors.collect($t('template_events.fields.type'))"
                        dense
                      />
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-select
                        v-model="payload.account_type"
                        v-validate="'required'"
                        :items="accountTypeOptions"
                        :label="$t('template_events.fields.account_type')"
                        :data-vv-name="$t('template_events.fields.account_type')"
                        :error-messages="errors.collect($t('template_events.fields.account_type'))"
                        dense
                      />
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-select
                        v-model="payload.module_id"
                        :items="modules"
                        item-text="name"
                        item-value="id"
                        :label="$t('template_events.fields.module')"
                        dense
                      />
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model="payload.name"
                        v-validate="'required'"
                        :label="$t('template_events.fields.name')"
                        :data-vv-name="$t('template_events.fields.name')"
                        :error-messages="errors.collect($t('template_events.fields.name'))"
                        dense
                      />
                    </v-col>
                    <v-col cols="12">
                      <v-textarea
                        v-model="payload.description"
                        v-validate="'required'"
                        :label="$t('template_events.fields.description')"
                        :data-vv-name="$t('template_events.fields.description')"
                        :error-messages="errors.collect($t('template_events.fields.description'))"
                        rows="2"
                        no-resize
                        dense
                      />
                    </v-col>
                    <v-col cols="12" class="d-flex align-center justify-space-between">
                      <div class="subtitle-2">
                        {{$t('template_events.fields.status') }}
                      </div>
                      <v-switch
                        v-model="status"
                        @change="setStatus"
                        color="primary"
                        class="ma-0 py-2"
                        hide-details
                      />
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" md="10">
              <v-card>
                <v-text-field
                  v-model="newVariable"
                  :label="$t('template_events.fields.variables')"
                  hide-details
                  solo
                  flat
                  class="pr-2"
                  append-icon="add"
                  @click:append="addVariable"
                />
                <v-divider />
                <v-card-text>
                  <v-row dense>
                    <v-col v-if="!payload.variables.length" cols="12">
                      <v-chip class="d-block text-center">
                        <div
                          class="d-flex align-center"
                          v-text="$t('template_events.fields.not_found_variables')"
                        />
                      </v-chip>
                    </v-col>
                    <v-col
                      v-for="(item, index) in payload.variables"
                      :key="index"
                      cols="6"
                      md="4"
                    >
                      <v-chip class="d-block pr-8">
                        <input
                          v-model="payload.variables[index]"
                          style="width: 100%;"
                        />
                        <v-btn
                          color="error"
                          x-small
                          icon
                          absolute
                          style="right:8px;"
                          @click="removeVariable(index)"
                        >
                          <v-icon small v-text="'clear'" />
                        </v-btn>
                      </v-chip>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import BaseToolbar from '@/components/BaseToolbar'
export default {
  components: {
    BaseToolbar
  },
  data () {
    return {
      loading: false,
      newVariable: '',
      status: false,
      typeOptions: [
        { text: 'Email', value: 'email' },
        { text: 'Landing', value: 'landing' },
        { text: 'PDF', value: 'pdf' }
      ],
      accountTypeOptions: [
        { text: 'Autoresponder', value: 'autoresponder' },
        { text: 'Certificates', value: 'certificate' },
        { text: 'Petition Notification', value: 'petition_notification' },
        { text: 'Petition Target', value: 'petition_target' }
      ],
      payload: {
        type: '',
        account_type: '',
        name: '',
        description: '',
        module_id: null,
        variables: [],
        status: ''
      }
    }
  },
  computed: {
    ...mapGetters({
      isOpenTemplateEventEditor: 'templateEvents/isOpenTemplateEventEditor',
      editorMode: 'templateEvents/editorMode',
      templateEvent: 'templateEvents/templateEvent',
      modules: 'templateEvents/modules'
    }),
    title () {
      if (this.editorMode === 'create') {
        return 'Crear evento de plantilla'
      } else if (this.editorMode === 'edit') {
        return 'Editar evento plantilla'
      } else {
        return 'Detalles de evento de plantilla'
      }
    }
  },
  watch: {
    isOpenTemplateEventEditor (newVal) {
      if (newVal) {
        if (this.editorMode === 'edit') {
          this.setEditData()
        }
      } else {
        this.setEditorMode('create')
        this.cleanData()
      }
    },
  },
  methods: {
    ...mapActions({
      saveTemplateEvent: 'templateEvents/saveTemplateEvent',
      updateTemplateEvent: 'templateEvents/updateTemplateEvent'
    }),
    ...mapMutations({
      setEditorMode: 'templateEvents/setEditorMode',
      toggleTemplateEventEditor: 'templateEvents/toggleTemplateEventEditor'
    }),
    setStatus (status) {
      status ? this.payload.status = 'active' : this.payload.status = 'archived'
    },
    setEditData () {
      this.payload = { ...this.templateEvent }
      this.payload.status === 'active'
        ? this.status = true
        : this.status = false
    },
    addVariable () {
      if (this.newVariable) {
        this.payload.variables.push(this.newVariable)
        this.newVariable = ''
      }
    },
    removeVariable (index) {
      this.payload.variables.splice(index, 1)
    },
    async submit () {
      const {
        editorMode,
        payload,
        close,
        saveTemplateEvent,
        updateTemplateEvent
      } = this
      const isValid = await this.$validator.validateAll()
      if (!isValid) { return }
      if (editorMode === 'create') {
        await saveTemplateEvent(payload)
      } else {
        await updateTemplateEvent(payload)
      }
      close()
    },
    cleanData () {
      this.payload = {
        type: '',
        account_type: '',
        name: '',
        description: '',
        module_id: null,
        variables: [],
        status: ''
      }
      this.$validator.reset()
      this.loading = false
    },
    close () {
      this.toggleTemplateEventEditor(false)
      this.cleanData()
    }
  }
}
</script>
